<template>
    <div id="paper-root" style="max-width: 1200px;margin: 0 auto;width: 100%;min-height: calc(100vh - 50px);">
        <template v-if="paperQuestion.length > 0">
            <a-layout theme="light" class="paper-style-2" style="min-height: calc(100vh - 70px);margin-top: 20px;">
                <a-layout>

                    <a-layout-content>
                        <div class="paper-content" :bordered="false">
                            <div class="paper-content-item" v-show="qi == currentQuestionIndex"
                                v-for="(q, qi) in paperQuestion" :key="qi">

                                <a-row>
                                    <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                        <a-card class="stem-card" :bordered="false"
                                            :headStyle="{ 'background': '#c8c8c84a' }"
                                            :bodyStyle="{ 'background': '#c8c8c84a' }">
                                            <span slot="title">
                                                <span>{{ getQuestionTypeText(q.questionType) }}</span>
                                                <span style="padding-left: 10px;color: #999" v-if="$route.query.name.indexOf('顺章练习') != -1">({{ currentQuestionIndex+1 }}/{{ dataInfo.total }})</span>
                                            </span>
                                            <div class="question-stem">
                                                <p style="float: left;"> {{ currentQuestionIndex+1 }}、</p>
                                                <div style="float: left;" v-html="q.questionStem"
                                                    :id="'question-stem-' + q.id">
                                                </div>
                                            </div>
                                        </a-card>
                                    </a-col>
                                    <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                        <a-card class="answer-card" title="" :bordered="false"
                                            :headStyle="{ 'background': '#c8c8c84a' }"
                                            :bodyStyle="{ 'background': '#c8c8c84a' }" v-if="paperAnswer.length > 0">
                                            <!-- 单选 -->
                                            <template v-if="q.questionType == 1">
                                                <div class="radioBox" v-for="(o, oi) in q.questionOptions" :key="oi" @click="questionChangeFn(oi,q,qi)">
                                                    <div class="radio-content">
                                                        <div class="question-letter radioList" v-if="paperAnswer[qi]['myAnswer'] == oi && q.gotScore > 0">
                                                            <i class="iconfont" style="color: rgb(39, 229, 18);">&#xe627;</i>
                                                        </div>
                                                        <div class="radioList question-letter" v-else-if="paperAnswer[qi]['myAnswer'] == oi && q.gotScore == 0"><i class="iconfont" style="color: red;">&#xe6a5;</i></div>
                                                        <div class="radioList question-letter" v-else>{{index2letter(oi)  }}</div>
                                                        <div class="question-options-content">
                                                            <div class="option" v-html="o.item"></div>
                                                        </div>
                                                    </div>
                                                </div> 
                                            </template>    
                                            
                                            <!-- 多选 -->
                                            <a-checkbox-group class="question-checkbox" v-if="q.questionType == 2"
                                                v-model="paperAnswer[qi]['myAnswer']">
                                                <a-checkbox v-for="(o, oi) in q.questionOptions" :key="oi" :value="oi">
                                                    <div class="checkbox-content">
                                                        <span class="question-letter">{{ index2letter(oi) }}
                                                        </span>
                                                        <div class="question-options-content">

                                                            <div class="option" v-html="o.item"></div>
                                                        </div>
                                                    </div>
                                                </a-checkbox>
                                            </a-checkbox-group>
                                            <!-- 判断题 -->
                                            <template v-if="q.questionType == 3">
                                                <div class="radioBox" @click="questionChangeFn('true',q,qi)">
                                                    <div class="radio-content">
                                                        <div class="question-letter radioList" v-if="paperAnswer[qi]['myAnswer'] == 'true' && q.gotScore > 0">
                                                            <i class="iconfont" style="color: rgb(39, 229, 18);">&#xe627;</i>
                                                        </div>
                                                        <div class="radioList question-letter" v-else-if="paperAnswer[qi]['myAnswer'] == 'true' && q.gotScore == 0"><i class="iconfont" style="color: red;">&#xe6a5;</i></div>
                                                        <div class="radioList question-letter" v-else>{{index2letter(0)  }}</div>
                                                        <div class="question-options-content">
                                                            <div class="option" >正确</div>
                                                        </div>
                                                    </div>
                                                </div> 
                                                <div class="radioBox" @click="questionChangeFn('false',q,qi)">
                                                    <div class="radio-content">
                                                        <div class="question-letter radioList" v-if="paperAnswer[qi]['myAnswer'] == 'false' && q.gotScore > 0">
                                                            <i class="iconfont" style="color: rgb(39, 229, 18);">&#xe627;</i>
                                                        </div>
                                                        <div class="radioList question-letter" v-else-if="paperAnswer[qi]['myAnswer'] == 'false' && q.gotScore == 0"><i class="iconfont" style="color: red;">&#xe6a5;</i></div>
                                                        <div class="radioList question-letter" v-else>{{index2letter(1)  }}</div>
                                                        <div class="question-options-content">
                                                            <div class="option" >错误</div>
                                                        </div>
                                                    </div>
                                                </div> 
                                            </template>    
                                            <!-- 填空题 -->
                                            <div class="question-fill-wrap" v-if="q.questionType == 4">
                                                <a-input class="question-fill"
                                                    v-for="oi in q.questionOptions.fillGapNum" :key="oi"
                                                    v-model="paperAnswer[qi]['myAnswer'][oi - 1]"
                                                    :addonBefore="'第' + oi + '空'" :placeholder="'请填写第' + oi + '空回答'"
                                                    @change="e => questionChangeFn(e, q, qi)" />
                                            </div>
                                            <!-- 主观题 -->
                                            <div class="question-read"
                                                v-if="q.questionType == 5">
                                                <a-textarea
                                                    :auto-size="{ minRows: 5, maxRows: 20 }"
                                                    :placeholder="$t('exam.answerArex')"
                                                    v-model="paperAnswer[qi]['myAnswer']"></a-textarea>
                                            </div>
                                            <!-- 阅读分析 -->
                                            <div class="question-read" v-if="q.questionType == 6">
                                                <hr>
                                                <div v-for="(o, oi) in q.questionOptions" :key="oi" class="sub-question">
                                                    <span class="sub-question-index">({{(oi+1)}}) </span>
                                                    <div class="sub-question-stem" v-html="o.stem"></div>
                                                    <a-radio-group class="question-radio" v-model="paperAnswer[qi]['myAnswer'][oi]">
                                                        <a-radio v-for="(oo, ooi) in o.options" :key="ooi" :value="ooi">
                                                            <div class="radio-content">
                                                                <span class="question-letter">{{ index2letter(ooi) }}</span>
                                                                <div class="question-options-content">
                                                                    <div class="option" v-html="oo.item"></div>
                                                                </div>
                                                            </div>
                                                        </a-radio>
                                                    </a-radio-group>
                                                </div>
                                            </div>
                                            <template v-if="q.anserError || (q.myAnswer != '' && q.gotScore == 0)">
                                                <p style="padding: 10px 0;font-size: 18px;color: #666;">
                                                    正确答案：{{ answer2Text(paperQuestion[qi]) }}</p>
                                                <p v-if="q.questionAnalysis" style="font-size: 18px;">解析：<span
                                                        v-html="q.questionAnalysis"></span></p>
                                            </template>
                                            <!-- 控制条 -->
                                            <div class="question-opt-btn">
                                                <div class="switch-btn">
                                                    <a-button class="prevBtn" type="primary" @click="prevQuestion"
                                                        v-show="currentQuestionIndex != 0">上一题</a-button>
                                                    <a-button class="nextBtn" type="primary" @click="nextQuestion"
                                                        v-show="(q.questionType == 1 || q.questionType == 3) && currentQuestionIndex != paperQuestion.length - 1">下一题</a-button>
                                                    <a-button class="nextBtn" type="primary" @click="submitDataFn(q, qi)"
                                                        v-show="(q.questionType == 4 || q.questionType == 2 || q.questionType == 5 || q.questionType == 6)">下一题</a-button>
                                                </div>
                                            </div>
                                        </a-card>
                                    </a-col>
                                </a-row>
                                <div>
                                    <div class="dtk_button" @click.stop="NoteTakingFn(q.questionId)">
                                        <i class="iconfont">&#xe64d;</i><span>笔记</span>
                                    </div>
                                    <template v-if="routeInfo.type != 'SC'">
                                        <div class="jj_button dtk_button" @click.stop="collectYesFn(q.questionId)"
                                            v-if="!collectStatus">
                                            <i class="iconfont">&#xe606;</i><span>收藏</span>
                                        </div>
                                        <div class="jj_button dtk_button" @click.stop="collectNoFn(q.questionId)"
                                            v-else>
                                            <i class="iconfont" style="color: #ffb300;">&#xe605;</i><span>取消</span>
                                        </div>
                                    </template>

                                </div>
                            </div>

                        </div>
                    </a-layout-content>
                </a-layout>
            </a-layout>
        </template>
        <template v-else>
            <div style="margin-top: 50px;">
                <a-empty description="暂无数据" />
            </div>
        </template>
        <a-modal title="记录笔记" :visible="NoteModalStatus" @ok="sumbitNote" @cancel="NoteModalStatus = false">
            <a-textarea v-model="noteValue" placeholder="请输入你的笔记内容" :auto-size="{ minRows: 3, maxRows: 5 }" />
        </a-modal>
    </div>
</template>

<script>
import Vue from 'vue'
import { getAction, postAction, postActionWithParam } from '@/api/manage'
import { mixinDevice } from '@/utils/mixin.js'
import { jumpMixins } from "@/utils/jumpMixins"
import { examMixins } from '@/utils/examMixins'
import { upload2Qiniu, dataURLtoBlob } from '@/utils/qiniu.js'
import JModal from '@/components/jeecg/JModal'
import Voice from '@/components/tools/Voice'
import { setStore,getStore } from '@/utils/storage'
export default {
    name: 'Examine',
    mixins: [mixinDevice, jumpMixins, examMixins],
    components: {
        JModal,
        Voice
    },
    data() {
        return {
            heightOffset: 0,
            paperId: '',
            departId: '',
            paperDeptId: '',
            eventApplyId: '', //报名ID
            eventApplyCategory: '', //报名赛项
            userPaperList: [],
            loadingUserPaperList: false,
            userPaperInfo: {}, //用户答题卡信息
            paperQuestion: [], //已经过转换的题目信息
            questionSections: {},//题目分类信息
            paperAnswer: [], // 答题卡信息
            undoCount: 0, //未作答题目数量
            isCurrentQuestionChange: false, // 当前题目是否已修改
            userPaperId: '', // 答题卡ID
            paperDescVisible: false, //试卷介绍是否可见
            selectPaperVisible: false, //选择试卷modal
            cameraList: [],
            currentCamera: '',
            mediaRecorder: null,
            screenRecorder: null,
            duration: 0, //用时
            remaining: 0, //剩余时间
            remainTimeText: '',
            examStatus: -1, //考试状态 -1预览 0已结束 1正在考试
            canSave: true, //防止保存试卷高频点击
            canSubmit: true, //防止提交试卷高频点击
            isSaved: false, //答题是否已保存
            drawerStatus: false,   //答题卡
            pageNo: 1,
            pageSize:15,
            dataInfo: {},
            collectStatus: false, //是否收藏
            NoteModalStatus: false,  //笔记弹框
            noteQuestionId: '',  //当前笔记id
            noteValue: '',  //笔记内容
            routeInfo: {},
            pageNoList:[],
            localStrogeName:'',
        }
    },
    watch: {
        paperAnswer: {
            handler(newValue, oldValue) {
                if (this.paperQuestion) {
                    this.isSaved = false
                    this.isCurrentQuestionChange = true
                    let undoCount = 0
                    this.paperQuestion[this.currentQuestionIndex]['isSubmit'] = true
                    for (let i = 0; i < this.paperQuestion.length; i++) {
                        if (!this.isWriteAnswer(i)) { undoCount++ }
                    }
                    this.undoCount = undoCount
                }
            },
            deep: true
        },
        currentQuestionIndex(newValue, oldValue) {
            console.log(newValue, '是否')
            if(this.paperQuestion.length > 0)this.iscollectData(this.paperQuestion[newValue].questionId)
        }
    },
    created() {
        let that = this
        this.localStrogeName = `${this.$route.query.pageType}_${this.$route.query.id}`
        this.routeInfo = this.$route.query
        if(getStore(this.localStrogeName) && this.routeInfo.name.indexOf('顺章练习') != -1){
            let number = getStore(this.localStrogeName)
            this.currentQuestionIndex = number
            this.pageSize = number + 5
        }else{
            this.currentQuestionIndex = 0
        }
        this.requestMyPaperQuestionInfo(this.routeInfo) //获取试卷列表
        //拦截未登录
        if (!this.$store.getters.userInfo) {
            this.$info({
                title: that.$t('sys.notLogin'),
                content: that.$t('exam.pleaseToLogin'),
                okText: that.$t('sys.toLogin'),
                onOk() {
                    that.toLogin()
                },
            });
            // return
        } else {
            console.log("userInfo", this.$store.getters.userInfo);
        }
    },
    mounted() {
        var that = this
        document.title = this.$route.query.name
    },
    beforeRouteLeave(to, from, next) {
        next()
    },
    //离开页面
    beforeDestroy() {

    },
    methods: {
        upload2Qiniu: upload2Qiniu,
        dataURLtoBlob: dataURLtoBlob,
        questionChangeFn(e, row, index) {
            let _this = this
            const data = {
                myAnswer: e,
                qid: row.questionId,
            }
            if (row.questionType == 1 || row.questionType == 3) {
                this.submitOneAnswer(data, index)
            }
        },
                //单选
        optionRadioFn(qi,oi){
            this.paperAnswer[qi]['myAnswer'] = oi
        },
        iscollectData(id) {
            getAction(`/teaching/collect/isCollect?sourceId=${id}`).then(res => {
                this.collectStatus = res.success
                this.$forceUpdate()
            })
        },
        collectYesFn(id) {
            getAction(`/teaching/collect/doCollect?sourceId=${id}&sourceType=4`).then(res => {
                if (res.success) {
                    this.$message.success('收藏成功!')
                    this.collectStatus = true
                }
            })
        },
        collectNoFn(id) {
            getAction(`/teaching/collect/cancelCollect?sourceId=${id}`).then(res => {
                if (res.success) {
                    this.$message.success('取消收藏成功!')
                    this.collectStatus = false
                }
            })
        },
        NoteTakingFn(id) {
            this.NoteModalStatus = true
            this.noteQuestionId = id
        },
        sumbitNote() {
            if (!this.noteValue) {
                this.$message.error('请输入笔记内容!')
                return
            }
            const data = {
                sourceType: '4',
                sourceId: this.noteQuestionId,
                comment: this.noteValue,
                score: 5
            }
            postAction('/teaching/comment/saveComment', data).then(res => {
                if (res.success) {
                    this.$message.success('笔记提交成功!')
                    this.NoteModalStatus = false
                }
            })
        },
        submitDataFn(row, index) {
            if (row.anserError) {
                this.nextQuestion()
            } else {
                this.submitOneAnswer(this.paperAnswer[index], index)
            }
        },
        //请求答题卡和题目
        requestMyPaperQuestionInfo(paperModal) {
            const data = {}
            var url = ''
            if (this.routeInfo.type != 'SC') {
                data.knowledgePoint = paperModal.id,
                data.random = paperModal.random == 1 ? true : false,
                data.pageSize = this.pageSize,
                data.pageNo = this.pageNo
                url='/teaching/teachingQuestion/getMyPublicList'
            }else{
                data.pageNo= this.pageNo
                data.pageSIze= 10
                url='/teaching/teachingQuestion/myCollectQuestion'
            }

            getAction(url, data).then((res) => {
                if (res.success && res.result != null) {
                    this.dataInfo = res.result
                    if (this.routeInfo.type != 'SC' && res.result.records.length > 0) this.iscollectData(res.result.records[0].questionId)
                    this.parseQuestion(res.result.records)
                } else {
                    this.$message.error(res.message)
                    this.userPaperId = ''
                    this.changeURLStatic("userPaperId", "")
                }
                this.canRequestQustion = true
            })
        },
        nextQuestion() {
            let _this = this
            window.document.dispatchEvent(new CustomEvent('viocePause'));
            if (this.currentQuestionIndex == this.paperQuestion.length - 1) {
                return
            }
            this.currentQuestionIndex++
            if (_this.currentQuestionIndex == (_this.paperQuestion.length - 2) && _this.pageNo < _this.dataInfo.pages) {
                _this.pageNo++
                _this.pageSize = 15
                _this.requestMyPaperQuestionInfo(_this.$route.query)
            }
        },
        prevQuestion() {
            let _this = this
            window.document.dispatchEvent(new CustomEvent('viocePause'));
            if(this.currentQuestionIndex == 0){
                return
            }
            this.currentQuestionIndex--
        },

        // 提交一个题目
        submitOneAnswer(Obj, index) {
            console.log("submitOneAnswer", Obj, index);
            let _this = this
            postActionWithParam( `/teaching/teachingQuestion/submitAnswer`,Obj, {questionId: Obj.qid,}).then((res) => {
                if (res.success) {
                    if (res.result.gotScore == res.result.questionScore) {
                        _this.nextQuestion()
                        _this.paperQuestion[index].anserError = false
                        _this.paperQuestion[index].gotScore = res.result.gotScore
                        _this.paperAnswer[index].myAnswer = Obj.myAnswer
                    } else {
                        _this.paperQuestion[index].anserError = true
                        _this.paperQuestion[index].questionAnalysis = res.result.questionAnalysis
                        _this.paperQuestion[index].questionAnswer = res.result.questionAnswer
                        _this.paperQuestion[index].gotScore = res.result.gotScore
                        _this.paperAnswer[index].myAnswer = Obj.myAnswer
                        _this.$forceUpdate()
                    }
                    // _this.paperQuestion[index].myAnswer = obj.myAnswer
                    setStore(_this.localStrogeName,_this.currentQuestionIndex)
                } else {
                    this.$message.warn(res.message)
                }
            }).catch((err) => {
                console.log('你的错误？')
                this.$message.warn(this.$t('sys.networkError'))
            })
        },

        //解析题目
        parseQuestion(question) {
            let that = this
            // this.paperQuestion = []
            // this.paperAnswer = []
            let currentSection = null;
            let preLoadEditorQuestion = null; // 预加载编辑器的题目
            for (let qi in question) {
                let q = question[qi]
                //解析题目分类
                if (q.questionSection) {
                    currentSection = qi
                    this.questionSections[qi] = {
                        text: q.questionSection,
                        count: 0,
                        score: 0
                    }
                }
                if (currentSection != null) {
                    this.questionSections[currentSection].count += 1;
                    this.questionSections[currentSection].score += q.questionScore;
                }
                if (q.questionOptions != null) {
                    q.questionOptions = JSON.parse(q.questionOptions)
                }
                q.anserError = null
                q.voiceText = this.getQuestionVoice(q)
                this.paperQuestion.push(q)
                if (q.myAnswer != null || q.myAnswerFile != null) {
                    that.paperAnswer.push({ qid: q.questionId, myAnswer: that.parseAnswer(q.questionType, q.myAnswer), myAnswerFile: q.myAnswerFile })
                 
                } else {
                    if (q.questionType == 2 || q.questionType == 4 || q.questionType == 6) {
                        //填空题 多选题 阅读题结构
                                that.paperAnswer.push({ qid: q.questionId, myAnswer: [] })
                        
                    } else {
                            that.paperAnswer.push({ qid: q.questionId, myAnswer: '' })
                    }
                }
                //渲染填空题dom
                if (q.questionType == 4) {
                    this.renderGapFillingStemDom(q, qi)
                }
                if (q.questionType == 7) {
                    preLoadEditorQuestion = q
                }
            }
        },
    },
}
</script>

<style lang="less" scoped>
@import url('../../assets/exam.less');

.sub-question{
    .sub-question-index, .sub-question-stem{
        font-size: 140%;
    }
}
</style>
